import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Equipment } from '@polaris-customerweb/sharedcomponents.garage';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EquipmentTelemetryDto } from './equipment.models';

@Injectable({ providedIn: 'root' })
export class EquipmentResourceService {
    private baseUrl: string;

    constructor(
        private configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'v1/equipment'
        );
    }

    getEquipmentTelemetry(
        equipmentId: string
    ): Observable<EquipmentTelemetryDto[]> {
        const url = this.routingHelpersService.combineUrl(
            this.configService.apiUrl.rideCommand,
            'equipment/telemetry'
        );
        const params = new HttpParams().set('equipmentId', equipmentId);
        return this.http.get<EquipmentTelemetryDto[]>(url, { params });
    }

    updateEquipment(equipment: Equipment): Observable<Equipment> {
        return this.http
            .put<Equipment>(this.baseUrl, equipment)
            .pipe(map(() => equipment));
    }

    deleteEquipment(equipmentId: string): Observable<string> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            equipmentId
        );
        return this.http.delete(url).pipe(map(() => equipmentId));
    }
}
